module.exports = __webpack_public_path__ + "static/img/radioCur.0f4b59a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/radioCur.png
// module id = /ydG
// module chunks = 21